import _toConsumableArray from "/home/henry/git/frontend-dojopy/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _toArray from "/home/henry/git/frontend-dojopy/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toArray";
import _createForOfIteratorHelper from "/home/henry/git/frontend-dojopy/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _asyncToGenerator from "/home/henry/git/frontend-dojopy/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
var _marked = /*#__PURE__*/_regeneratorRuntime().mark(editor);
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return { value: void 0, done: !0 }; } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable || "" === iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } throw new TypeError(typeof iterable + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import React, { useRef, useEffect, memo } from 'react';
function type(_x) {
  return _type.apply(this, arguments);
}
function _type() {
  _type = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(node) {
    var _len,
      args,
      _key,
      _i,
      _args5,
      arg,
      _args6 = arguments;
    return _regeneratorRuntime().wrap(function _callee3$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          for (_len = _args6.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = _args6[_key];
          }
          _i = 0, _args5 = args;
        case 2:
          if (!(_i < _args5.length)) {
            _context5.next = 21;
            break;
          }
          arg = _args5[_i];
          _context5.t0 = typeof arg;
          _context5.next = _context5.t0 === 'string' ? 7 : _context5.t0 === 'number' ? 10 : _context5.t0 === 'function' ? 13 : 16;
          break;
        case 7:
          _context5.next = 9;
          return edit(node, arg);
        case 9:
          return _context5.abrupt("break", 18);
        case 10:
          _context5.next = 12;
          return wait(arg);
        case 12:
          return _context5.abrupt("break", 18);
        case 13:
          _context5.next = 15;
          return arg.apply(void 0, [node].concat(args));
        case 15:
          return _context5.abrupt("break", 18);
        case 16:
          _context5.next = 18;
          return arg;
        case 18:
          _i++;
          _context5.next = 2;
          break;
        case 21:
        case "end":
          return _context5.stop();
      }
    }, _callee3);
  }));
  return _type.apply(this, arguments);
}
function edit(_x2, _x3) {
  return _edit.apply(this, arguments);
}
function _edit() {
  _edit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(node, text) {
    var overlap;
    return _regeneratorRuntime().wrap(function _callee4$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          overlap = getOverlap(node.textContent, text);
          _context6.next = 3;
          return perform(node, [].concat(_toConsumableArray(deleter(node.textContent, overlap)), _toConsumableArray(writer(text, overlap))));
        case 3:
        case "end":
          return _context6.stop();
      }
    }, _callee4);
  }));
  return _edit.apply(this, arguments);
}
function wait(_x4) {
  return _wait.apply(this, arguments);
}
function _wait() {
  _wait = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(ms) {
    return _regeneratorRuntime().wrap(function _callee5$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return new Promise(function (resolve) {
            return setTimeout(resolve, ms);
          });
        case 2:
        case "end":
          return _context7.stop();
      }
    }, _callee5);
  }));
  return _wait.apply(this, arguments);
}
function perform(_x5, _x6) {
  return _perform.apply(this, arguments);
}
function _perform() {
  _perform = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(node, edits) {
    var speed,
      _iterator2,
      _step2,
      op,
      _args9 = arguments;
    return _regeneratorRuntime().wrap(function _callee6$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          speed = _args9.length > 2 && _args9[2] !== undefined ? _args9[2] : 60;
          _iterator2 = _createForOfIteratorHelper(editor(edits));
          _context8.prev = 2;
          _iterator2.s();
        case 4:
          if ((_step2 = _iterator2.n()).done) {
            _context8.next = 11;
            break;
          }
          op = _step2.value;
          op(node);
          _context8.next = 9;
          return wait(speed + speed * (Math.random() - 0.5));
        case 9:
          _context8.next = 4;
          break;
        case 11:
          _context8.next = 16;
          break;
        case 13:
          _context8.prev = 13;
          _context8.t0 = _context8["catch"](2);
          _iterator2.e(_context8.t0);
        case 16:
          _context8.prev = 16;
          _iterator2.f();
          return _context8.finish(16);
        case 19:
        case "end":
          return _context8.stop();
      }
    }, _callee6, null, [[2, 13, 16, 19]]);
  }));
  return _perform.apply(this, arguments);
}
function editor(edits) {
  var _iterator, _step, _loop;
  return _regeneratorRuntime().wrap(function editor$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        _iterator = _createForOfIteratorHelper(edits);
        _context2.prev = 1;
        _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
          var edit;
          return _regeneratorRuntime().wrap(function _loop$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                edit = _step.value;
                _context.next = 3;
                return function (node) {
                  return requestAnimationFrame(function () {
                    return node.textContent = edit;
                  });
                };
              case 3:
              case "end":
                return _context.stop();
            }
          }, _loop);
        });
        _iterator.s();
      case 4:
        if ((_step = _iterator.n()).done) {
          _context2.next = 8;
          break;
        }
        return _context2.delegateYield(_loop(), "t0", 6);
      case 6:
        _context2.next = 4;
        break;
      case 8:
        _context2.next = 13;
        break;
      case 10:
        _context2.prev = 10;
        _context2.t1 = _context2["catch"](1);
        _iterator.e(_context2.t1);
      case 13:
        _context2.prev = 13;
        _iterator.f();
        return _context2.finish(13);
      case 16:
      case "end":
        return _context2.stop();
    }
  }, _marked, null, [[1, 10, 13, 16]]);
}
function writer(_ref2) {
  var _ref3 = _toArray(_ref2),
    text = _ref3.slice(0);
  var startIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var endIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : text.length;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (!(startIndex < endIndex)) {
            _context3.next = 5;
            break;
          }
          _context3.next = 3;
          return text.slice(0, ++startIndex).join('');
        case 3:
          _context3.next = 0;
          break;
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee);
  })();
}
function deleter(_ref4) {
  var _ref5 = _toArray(_ref4),
    text = _ref5.slice(0);
  var startIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var endIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : text.length;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    return _regeneratorRuntime().wrap(function _callee2$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (!(endIndex > startIndex)) {
            _context4.next = 5;
            break;
          }
          _context4.next = 3;
          return text.slice(0, --endIndex).join('');
        case 3:
          _context4.next = 0;
          break;
        case 5:
        case "end":
          return _context4.stop();
      }
    }, _callee2);
  })();
}
function getOverlap(start, _ref6) {
  var _ref7 = _toArray(_ref6),
    end = _ref7.slice(0);
  return [].concat(_toConsumableArray(start), [NaN]).findIndex(function (char, i) {
    return end[i] !== char;
  });
}
function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}
var css = ".styles_typicalWrapper__1_Uvh::after {\n  content: \"|\";\n  animation: styles_blink__2CKyC 1s infinite step-start;\n}\n\n@keyframes styles_blink__2CKyC {\n  50% { opacity: 0; }\n}";
var styles = {
  "typicalWrapper": "styles_typicalWrapper__1_Uvh",
  "blink": "styles_blink__2CKyC"
};
styleInject(css);
var toConsumableArray = function toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
    return arr2;
  } else {
    return Array.from(arr);
  }
};
var Typical = function Typical(_ref) {
  var steps = _ref.steps,
    loop = _ref.loop,
    className = _ref.className,
    _ref$wrapper = _ref.wrapper,
    wrapper = _ref$wrapper === undefined ? "p" : _ref$wrapper;
  var typicalRef = useRef(null);
  var Component = wrapper;
  var classNames = [styles.typicalWrapper];
  if (className) {
    classNames.unshift(className);
  }
  useEffect(function () {
    if (loop === Infinity) {
      type.apply(undefined, [typicalRef.current].concat(toConsumableArray(steps), [type]));
    } else if (typeof loop === "number") {
      type.apply(undefined, [typicalRef.current].concat(toConsumableArray(Array(loop).fill(steps).flat())));
    } else {
      type.apply(undefined, [typicalRef.current].concat(toConsumableArray(steps)));
    }
  });
  return React.createElement(Component, {
    ref: typicalRef,
    className: classNames.join(' ')
  });
};
var index = memo(Typical);
export default index;